import LogIn from './list/login';
import Registration from './list/registration';
import ForgotPassword from './list/forgotpassword';
import RegisterVerification from './list/registerVerification';

export { LogIn, Registration, ForgotPassword, RegisterVerification };